import { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import { Clock } from "react-bootstrap-icons";
import { showMoneyShort } from "../Data/Money";
import { showDuration } from "../Data/Date";
import { Button } from "./Button";
import { RateProgram } from "../Data/ApiTypes";
import { rateProgramType } from "../Data/RateProgram";
import "./RatesModal.scss";

export interface RatesModalProps {
    show:    RateProgram[] | undefined;
    setShow: ( value: RateProgram[] | undefined ) => void;
}

function RateTimeWindow( { timeRange }: { timeRange: ReturnType<typeof rateProgramType> } ) {
    if( !timeRange ) {
        return null;
    }
    if( typeof timeRange === "string" ) {
        return (
            <div className="rates-modal__window">
                <Clock size={14} className="rates-modal__window-icon" />
                <span>{timeRange}</span>
            </div>
        );
    }
    return (
        <div className="rates-modal__window">
            <Clock size={14} className="rates-modal__window-icon" />
            <div>{timeRange as ReactNode}</div>
        </div>
    );
}

export function RatesModal( props: RatesModalProps ) {
    const { show, setShow } = { ...props };
    return (
        <Modal show={!!show}
               centered
               keyboard
               dialogClassName="rates-modal"
               onHide={ () => setShow( undefined ) }>
            <Modal.Header closeButton closeVariant="white" className="header-gradient">
                <div className="rates-modal__header">
                    <div className="fs-4 fw-bold">Hourly Rates</div>
                    <div className="rates-modal__subtitle">Available parking options</div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="rates-modal__programs">
                    {show?.map( prog => {
                        const timeRange = rateProgramType( prog );
                        return (
                            <div key={prog.rateProgramId} className="rates-modal__program">
                                <div className="rates-modal__program-name">
                                    {prog.name}
                                </div>
                                <RateTimeWindow timeRange={timeRange} />
                                <div className="rates-modal__entries">
                                    {prog.entries.map( rate => (
                                        <div key={rate.rateEntryId} className="rates-modal__entry">
                                            <span className="rates-modal__duration">
                                                Up to {showDuration( rate.upTo )}
                                            </span>
                                            <span className="rates-modal__price">
                                                {showMoneyShort( rate.rate )}
                                            </span>
                                        </div>
                                    ) )}
                                </div>
                            </div>
                        );
                    } )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="w-100 btn-main" onClick={() => setShow( undefined )}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
